/* eslint-disable camelcase */
import React, { Component } from 'react';
import styled from 'styled-components';

import { fetchElementValues } from '../actions/elements';
import { Button } from './Button';
import { Input } from './Input';

const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  > div {
    flex-basis: 49%;
    margin: 5px auto;
  }

  > button {
    margin: 20px 0;
  }
`;

export class ElementEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.element ? props.element.id : '',
      location: props.element ? props.element.location : '',
      country: props.element ? props.element.country : '',
      air_humidity: props.element ? props.element.air_humidity : '',
      air_temperature: props.element ? props.element.air_temperature : '',
      street: props.element ? props.element.street : '',
      rl: props.element ? props.element.rl : '',
      rw: props.element ? props.element.rw : '',
      qd: props.element ? props.element.qd : '',
      material_type: props.element ? props.element.material_type : '',
      line: props.element ? props.element.line : '',
      coordinates: props.element ? props.element.coordinates : '',
      position: props.element ? props.element.position : '',
      grit_beads: props.element ? props.element.grit_beads : '',
      grit_type: props.element ? props.element.grit_type : '',
      SRT: props.element ? props.element.SRT : '',
      date: props.element ? props.element.date : '',
      application_date: props.element ? props.element.application_date : '',
      notification_date: props.element ? props.element.notification_date : '',
      remarks: props.element ? props.element.remarks : '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleHumidityChange = this.handleHumidityChange.bind(this);
    this.handleTemperatureChange = this.handleTemperatureChange.bind(this);
    this.handleStreetChange = this.handleStreetChange.bind(this);
    this.handleRlChange = this.handleRlChange.bind(this);
    this.handleRwChange = this.handleRwChange.bind(this);
    this.handleQdChange = this.handleQdChange.bind(this);
    this.handleMaterialChange = this.handleMaterialChange.bind(this);
    this.handleLineChange = this.handleLineChange.bind(this);
    this.handleCoordinatesChange = this.handleCoordinatesChange.bind(this);
    this.handlePositionChange = this.handlePositionChange.bind(this);
    this.handleBreadsChange = this.handleBreadsChange.bind(this);
    this.handleSRTChange = this.handleSRTChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleAppDateChange = this.handleAppDateChange.bind(this);
    this.handleNotifDateChange = this.handleNotifDateChange.bind(this);
    this.handleRemarksChange = this.handleRemarksChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
  }

  componentDidMount() {
    fetchElementValues(this.props.element.id)
      .then((data) => {
        this.setState({
          id: data.id || '',
          location: data.location || '',
          country: data.country || '',
          air_humidity: data.air_humidity || '',
          air_temperature: data.air_temperature || '',
          street: data.street || '',
          rl: data.rl || '',
          rw: data.rw || '',
          qd: data.qd || '',
          material_type: data.material_type || '',
          line: data.line || '',
          coordinates: data.coordinates || '',
          position: data.position || '',
          grit_beads: data.grit_beads || '',
          grit_type: data.grit_type || '',
          SRT: data.SRT || '',
          date: data.date || '',
          application_date: data.application_date || '',
          notification_date: data.notification_date || '',
          remarks: data.remarks || '',
        });
      });
  }

  handleLocationChange(e) {
    this.setState({ location: e.target.value });
  }

  handleCountryChange(e) {
    this.setState({ country: e.target.value });
  }

  handleHumidityChange(e) {
    this.setState({ air_humidity: e.target.value });
  }

  handleTemperatureChange(e) {
    this.setState({ air_temperature: e.target.value });
  }

  handleStreetChange(e) {
    this.setState({ street: e.target.value });
  }

  handleRlChange(e) {
    this.setState({ rl: e.target.value });
  }

  handleRwChange(e) {
    this.setState({ rw: e.target.value });
  }

  handleQdChange(e) {
    this.setState({ qd: e.target.value });
  }

  handleMaterialChange(e) {
    this.setState({ material_type: e.target.value });
  }

  handleLineChange(e) {
    this.setState({ line: e.target.value });
  }

  handleCoordinatesChange(e) {
    this.setState({ coordinates: e.target.value });
  }

  handlePositionChange(e) {
    this.setState({ position: e.target.value });
  }

  handleBreadsChange(e) {
    this.setState({ grit_beads: e.target.value });
  }

  handleTypeChange(e) {
    this.setState({ grit_type: e.target.value });
  }

  handleSRTChange(e) {
    this.setState({ SRT: e.target.value });
  }

  handleDateChange(e) {
    this.setState({ date: e.target.value });
  }

  handleAppDateChange(e) {
    this.setState({ application_date: e.target.value });
  }

  handleNotifDateChange(e) {
    this.setState({ notification_date: e.target.value });
  }

  handleRemarksChange(e) {
    this.setState({ remarks: e.target.value });
  }

  handleSubmit() {
    this.props.onSave(this.state);
  }

  render() {
    const {
      location,
      air_humidity,
      air_temperature,
      street,
      country,
      rl,
      rw,
      qd,
      material_type,
      line,
      position,
      grit_beads,
      grit_type,
      SRT,
      date,
      application_date,
      notification_date,
      remarks,
    } = this.state;

    return (
      <InputWrapper>
        <Input
          onChange={this.handleLocationChange}
          placeholder="Location"
          type="text"
          value={location || ''}
        />
        <Input
          onChange={this.handleHumidityChange}
          placeholder="Air Humidity"
          type="number"
          value={air_humidity || ''}
        />
        <Input
          onChange={this.handleTemperatureChange}
          placeholder="Air Temperature"
          type="number"
          value={air_temperature || ''}
        />
        <Input
          onChange={this.handleCountryChange}
          placeholder="Country"
          type="text"
          value={country || ''}
        />
        <Input
          onChange={this.handleStreetChange}
          placeholder="Street"
          type="text"
          value={street || ''}
        />
        <Input
          onChange={this.handleRlChange}
          placeholder="RL"
          type="number"
          value={rl || ''}
        />
        <Input
          onChange={this.handleRwChange}
          placeholder="RW"
          type="number"
          value={rw || ''}
        />
        <Input
          onChange={this.handleQdChange}
          placeholder="QD"
          type="number"
          value={qd || ''}
        />
        <Input
          onChange={this.handleMaterialChange}
          placeholder="Material Type"
          value={material_type || ''}
        />
        <Input
          onChange={this.handleLineChange}
          placeholder="Line"
          value={line || ''}
        />
        {/* <Input
          onChange={this.handleCoordinatesChange}
          placeholder="Coordinates"
          value={coordinates || ''}
        /> */}
        <Input
          onChange={this.handlePositionChange}
          placeholder="Position"
          value={position || ''}
        />
        <Input
          onChange={this.handleBreadsChange}
          placeholder="Grit Beads"
          value={grit_beads || ''}
        />
        <Input
          onChange={this.handleTypeChange}
          placeholder="Grit Type"
          value={grit_type || ''}
        />
        <Input
          onChange={this.handleSRTChange}
          placeholder="SRT"
          value={SRT || ''}
        />
        <Input
          onChange={this.handleDateChange}
          placeholder="Date"
          type="date"
          value={date || ''}
        />
        <Input
          onChange={this.handleAppDateChange}
          placeholder="Application date"
          type="date"
          value={application_date || ''}
        />
        <Input
          onChange={this.handleNotifDateChange}
          placeholder="Notification date"
          type="date"
          value={notification_date || ''}
        />
        <Input
          onChange={this.handleRemarksChange}
          placeholder="Remarks"
          type="text"
          value={remarks || ''}
        />
        <div />
        <Button
          block
          onClick={this.handleSubmit}
        >
          SAVE
        </Button>
      </InputWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ElementEdit.js